// =====================================================
// 📁 quotationHistoryTableActions.ts
// =====================================================

import { ActionItem } from '../../../types/button/ActionButton';
import { QuotationPermissions } from '../quotationPermissions';

export const getQuotationHistoryTableActions = ({
  row,
  permissions,
  handlers,
}: {
  row: any;

  permissions: QuotationPermissions;

  handlers: {
    onView: (id: number) => void;

    onPdf: (quotation: any) => void;

    onCancel: (id: number) => void;

    onProcess: (id: number) => void;
  };
}): ActionItem[] => {
  const actions: ActionItem[] = [];

  // =====================================================
  // 🔹 Ver
  // =====================================================

  if (permissions.canView) {
    actions.push({
      key: 'view',
      label: 'Ver Cotización',
      onClick: () => handlers.onView(row.id),
    });
  }

  // =====================================================
  // 🔹 PDF
  // =====================================================

  if (permissions.canPdf) {
    actions.push({
      key: 'pdf',
      label: 'Descargar PDF',
      onClick: () => handlers.onPdf(row),
    });
  }

  // =====================================================
  // 🔹 Activas
  // =====================================================

  if (row.status === 'ACTIVE') {
    if (permissions.canProcess) {
      actions.push({
        key: 'process',
        label: 'Procesar Venta',
        onClick: () => handlers.onProcess(row.id),
      });
    }

    if (permissions.canCancel) {
      actions.push({
        key: 'cancel',
        label: 'Cancelar',
        onClick: () => handlers.onCancel(row.id),
      });
    }
  }

  return actions;
};
